module.exports = __webpack_public_path__ + "img/pt-37.59e0cc9c.jpg";